import React from 'react'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SelectUI from '../../../widgets/input/SelectUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import CardUI from '../../../widgets/layout/CardUI'
import './MutualFundsList.css'

const MutualFundsListUI = ({
  context, accountNumber, onRefreshClick,
  mfTransferList, totals, mfTransactions, mfMonthlyTotals, mfTxnList,
  financialYear, financialYearList, onFinancialYearChange
}) =>
  <div className='pg_su_mf'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          accountNumber={accountNumber}
        />
      }
      right={
        <ActionRightUI
          context={context}
          financialYear={financialYear}
          financialYearList={financialYearList}
          onFinancialYearChange={onFinancialYearChange}
        />
      }
    />
    <MutualFundsMonthlyUI accountNumber={accountNumber} mfTransactions={mfTransactions} mfMonthlyTotals={mfMonthlyTotals} />
    {/* {
      mfTransferList.length === 0 &&
      <EmptyListUI className='g_m_top_100'
        context={context}
        createEnabled={false}
        createDisabledMessageLabel='No fixed deposits'
      />
    }
    {
      mfTransferList.length > 0 &&
      <div>
        <MutualFundsUI accountNumber={accountNumber} mfTransferList={mfTransferList} totals={totals} />
      </div>
    } */}
    {
      mfTxnList && mfTxnList.length > 0 &&
      <MutualFundsTxnListUI mfTxnList={mfTxnList} />
    }
  </div>

const MutualFundsMonthlyUI = ({ accountNumber, mfTransactions, mfMonthlyTotals }) =>
  <CardUI className='g_m_top_100'>
    <table className='g_table_3'><tbody>
      <tr>
        <th />
        <th>Opening Balance</th>
        <th>Mutual Funds Booked</th>
        <th>Mutual Funds Withdrawal</th>
        <th>Closing Balance</th>
      </tr>
      {
        mfTransactions && mfTransactions.map((mf, i) =>
          <tr key={i}>
            <td>{mf.monthYear}</td>
            <td className='g_text_right g_p_left_100'>{mf.openingBalanceF4}</td>
            <td className='g_text_right g_p_left_100'>{mf.mfBookedAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{mf.mfWithdrawalAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{mf.runningBalanceF4}</td>
          </tr>
        )
      }
      {
        mfMonthlyTotals &&
        <tr>
          <td><b>Total</b></td>
          <td />
          <td className='g_text_right g_p_left_100'><b>{mfMonthlyTotals.mfBooked}</b></td>
          <td className='g_text_right g_p_left_100'><b>{mfMonthlyTotals.mfWithdrawal}</b></td>
          <td />
        </tr>
      }
    </tbody></table>
  </CardUI>

const MutualFundsTxnListUI = ({ mfTxnList }) =>
  <CardUI className='g_m_top_100' title='All Mutual Funds Transfers'>
    <table className='g_table_3'><tbody>
      <tr>
        <th>Date</th>
        <th>Mutual Funds Booked</th>
        <th>Mutual Funds Withdrawal</th>
        <th>Closing Balance</th>
      </tr>
      {
        mfTxnList && mfTxnList.map((mf, i) =>
          <tr key={i}>
            <td>{mf.transactionDateF}</td>
            <td className='g_text_right g_p_left_100'>
              {
                mf.amount < 0 &&
                <>({mf.amountF1})</>
              }
            </td>
            <td className='g_text_right g_p_left_100'>
              {
                mf.amount >= 0 &&
                <>{mf.amountF1}</>
              }
            </td>
            <td className='g_text_right g_p_left_100'>
              {
                mf.balanceAmount >= 0 &&
                <>{mf.balanceAmountF1}</>
              }
              {
                mf.balanceAmount < 0 &&
                <>({mf.balanceAmountF1})</>
              }
            </td>
          </tr>
        )
      }
    </tbody></table>
  </CardUI>

const MutualFundsUI = ({ accountNumber, mfTransferList, totals }) =>
  <CardUI title={`Mutual Funds in ${accountNumber}`} className='g_m_top_100'>
    <div className='g_flex_h g_flex_right'>
      Current Mutual Funds booked:
      <BadgeUI className='g_m_left_50' label={`₹${totals.mfBookedCurrentF4}`} />
    </div>
    <table className='g_table_3'><tbody>
      <tr>
        <th>Mutual Funds Account</th>
        <th>Mutual Funds Booked</th>
        <th>Mutual Funds Amount</th>
        <th>Withdrawal</th>
        <th>Amount</th>
        <th>Interest Earned</th>
      </tr>
      {
        mfTransferList.map((mf, i) =>
          <tr key={i}>
            <td>{mf.mfAccount}</td>
            <td className='g_text_right g_p_left_100'>{mf.mfBookedDateF}</td>
            <td className='g_text_right g_p_left_100'>{mf.mfBookedAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{mf.mfWithdrawalDateF}</td>
            <td className='g_text_right g_p_left_100'>{mf.mfWithdrawalAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{mf.interestEarnedF4}</td>
          </tr>
        )
      }
      <tr>
        <td><b>Total</b></td>
        <td></td>
        <td className='g_text_right g_p_left_100'><b>{totals.mfBookedTotalF4}</b></td>
        <td></td>
        <td className='g_text_right g_p_left_100'><b>{totals.mfWithdrawalTotalF4}</b></td>
        <td className='g_text_right g_p_left_100'><b>{totals.mfInterestEarnedF4}</b></td>
      </tr>
    </tbody></table>
  </CardUI>

const ActionLeftUI = ({ onRefreshClick, accountNumber }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Mutual Funds in {accountNumber}</b></span>
  </div>

const ActionRightUI = ({ financialYear, financialYearList, onFinancialYearChange }) =>
  <span className='g_flex_h g_flex_right'>
    <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
  </span>

export default MutualFundsListUI
